import type { SortingState } from '@tanstack/react-table';
import { Done } from '../../components/product-table/columns/done-column';
import { LastReceived } from '../../components/product-table/columns/last-received-column';
import { ProductNameWithLabels } from '../../components/product-table/columns/product-name-with-labels-column';
import { QOH } from '../../components/product-table/columns/qoh-column';
import { getUnitsSoldColumn } from '../../components/product-table/columns/sales-columns';
import {
  Brand,
  Department,
  Description,
  Type,
} from '../../components/product-table/columns/simple-columns';
import { Size } from '../../components/product-table/columns/size-column';
import { SizeOunces } from '../../components/product-table/columns/size-ounces-column';
import { VendorName } from '../../components/product-table/columns/vendor-name-column';
import { ProductReport } from '../../components/product-table/product-report';
import type { StrictColumnDef } from '../../components/tanstack-table/column';
import type { Product } from '../../data/product';
import type { Filters } from '../../hooks/products';
import { productReportsLayout } from '../../router';

// Display columns
const displayColumns: StrictColumnDef<Product>[] = [
  Department,
  VendorName,
  ProductNameWithLabels,
  Type,
  Size,
  QOH,
  LastReceived,
  getUnitsSoldColumn(1),
];

// Sort columns (includes hidden columns for sorting)
const allColumnsForSort: StrictColumnDef<Product>[] = [
  ...displayColumns,
  SizeOunces,
  Brand,
  Description,
  Done, // Include Done column for print but hidden
];

// Multi-column sort order
const sorting: SortingState = [
  { id: Department.id, desc: false },
  { id: SizeOunces.id, desc: true },
  { id: Type.id, desc: false },
  { id: Brand.id, desc: false },
  { id: Description.id, desc: true },
];

// Column visibility: hide the sort-only columns and Done column
const columnVisibility = {
  [SizeOunces.id]: false,
  [Brand.id]: false,
  [Description.id]: false,
  [Done.id]: false,
};

const defaultFilters: Filters = { soldIn: 1, minimumInventory: 1 };

export function PreviousDaySalesReport() {
  const products = productReportsLayout.useLoaderData();

  return (
    <ProductReport
      products={products}
      title="Previous Day Sales"
      defaultFilters={defaultFilters}
      columns={allColumnsForSort}
      sorting={sorting}
      columnVisibility={columnVisibility}
    />
  );
}
